import { useCallback, useContext, useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import * as Yup from "yup";
import DynamicEmployeeForm from "../../EmployeeList/DynamicEmployeeForm";
import { TostMsg } from "../../../../App";

const BasicInfo = (params) => {
  const {
    employeeAllData,
    employeeId,
    employeeKeyDeta,
    EmployeeBasicDetails,
    updateEmployeeDetails,
  } = params;
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [employeeBasicFormData, setEmployeeBasicFormData] = useState([]);
  const [backButtonHide, setBackButtonHide] = useState(false);
  const [showContent, setSeleteContent] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);

  useEffect(() => {
    permissionAccouncementList();
    if (employeeKeyDeta) {
      let BasicForm = employeeKeyDeta?.filter(
        (item) => item.KeyCategoryName == "Basic"
      );
      setEmployeeBasicFormData(BasicForm);
    }
  }, [employeeKeyDeta]);

  const handleClick = () => {
    updateEmployeeDetails();
  };

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleCloseBasicInfoModal = () => {
    document.querySelector("#edit-basic-info .btn-close")?.click();
  };

  const renderForm = (type) => {
    handleClick();
    document.querySelector("#edit-basic-info .btn-close")?.click();
    if (type == "profile") {
      const tabTriggerEl = document.querySelector('a[href="#my-posts"]');
      if (tabTriggerEl) {
        const tab = new window.bootstrap.Tab(tabTriggerEl);
        tab.show();
      }
    }
  };

  const hasRequiredData = EmployeeBasicDetails?.some(
    (data) => data?.KeyCategoryId === 101
  );

  return (
    <>
      <div className="mb-4">
        {hasRequiredData ? (
          <div className="form-head stuck-headers33 mt-3">
            <div className="form-head stuck-header profile-about-me">
              <div className="mb-0">
                <h4 className="text-primary mb-3 sumh4 addprofile-action">
                  Basic Info
                  {userDetails?.EmpId == employeeId && (
                    <span>
                      <a
                        className="edit-btncss mb-2 love-icon"
                        data-bs-toggle="modal"
                        aria-label="Badge"
                        data-bs-target="#edit-basic-info"
                        title="Edit"
                      >
                        <img src="/images/org-img/edit.png" className="" />
                      </a>
                    </span>
                  )}
                </h4>
                <div className="languages-wrapper90">
                  {EmployeeBasicDetails?.filter(
                    (data) => data?.KeyCategoryId === 101
                  )
                    .sort((a, b) => a.KeyDisplayOrder - b.KeyDisplayOrder)
                    .map((data) => (
                      <>
                        {data.InferredValue != "" &&
                          data.InferredValue != null && (
                            <div className="languages-item" key={data.Id}>
                              <div className="icon-wrap">
                                <LazyImage src={data?.Icon} />
                              </div>
                              <div className="meta">
                                <span className="dark-inverted">
                                  {data.KeyDesc}
                                </span>
                                <span>{data.InferredValue}</span>
                              </div>
                            </div>
                          )}
                      </>
                    ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
           
          </>
        )}
      </div>

      <div
        id="edit-basic-info"
        className="modal fade custom-modal-area max-width-567"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content add-editexperience">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>
              <button
                onClick={handleCloseBasicInfoModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <h5 className="modal-title text-center">Basic Information</h5>
              {employeeBasicFormData.length > 0 && (
                <DynamicEmployeeForm
                  employeeKeyDeta={employeeBasicFormData}
                  employeeEditDetails={employeeAllData}
                  renderForm={renderForm}
                  backButtonHideStatus={backButtonHide}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfo;
